export default "__VITE_ASSET__DpwXS1Fu__"